import { Fragment } from "react";
import { Disclosure, Menu, Transition } from "@headlessui/react";
import { Bars3Icon, BellIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { Icon } from "@iconify/react";
import { NavLink } from "react-router-dom";
import logo from "../assets/images/logo for oceanic/logo.png";

const navigation = [
  { name: "Home", href: "#", current: true },
  { name: "White Paper", href: "#", current: false },
  { name: "Partners", href: "#", current: false },
  { name: "The Game", href: "#", current: false },
  {
    name: "Pinksale",
    href: "https://www.pinksale.finance/launchpad/0x892C7A01a850aC61dAaEB2B650f9B3D0f2519996?chain=BSC",
    current: false,
  },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Navbar() {
  return (
    <>
      <Disclosure
        as="nav"
        //   className="bg-gray-800"
        style={{
          background: "transparent",
          position: "absolute",
          width: "100%",
        }}
      >
        {({ open }) => (
          <>
            <div className="mx-auto w-[100%] lg:max-w-[86%] px-2 sm:px-6 lg:px-7 mt-[20px] lg:mt-[50px]">
              <div className="relative flex h-16 items-center justify-between">
                <div className="absolute z-[999] inset-y-0 right-0 flex items-center md:hidden">
                  {/* Mobile menu button */}
                  <Disclosure.Button className="relative inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:outline-non">
                    <span className="absolute -inset-0.5" />
                    <span className="sr-only">Open main menu</span>
                    {open ? (
                      <XMarkIcon className="block h-6 w-6" aria-hidden="true" />
                    ) : (
                      <Bars3Icon className="block h-6 w-6" aria-hidden="true" />
                    )}
                  </Disclosure.Button>
                </div>
                <div className="absolute w-[100%] z-[99] flex flex-1 items-center justify-start sm:items-stretch">
                  <div className="flex flex-shrink-0 items-center ps-[10px]">
                    <img
                      className="h-8 w-[100px]"
                      src={logo}
                      alt="Your Company"
                    />
                  </div>
                  <div className="hidden sm:ml-6 sm:block">
                    <nav
                      aria-label="primary"
                      class="relative gap-0 z-20 flex-col w-full flex-grow text-white hidden pb-4 md:pb-0 md:flex md:justify-end md:flex-row"
                    >
                      <div class="relative group">
                        <button class="flex flex-row items-center w-full lg:px-4 py-4 mt-2 text-base font-semibold text-left  uppercase bg-transparent rounded-lg md:w-auto md:inline md:mt-0 md:ml-4 focus:outline-none font-montserrat">
                          <div class="flex items-center gap-2">
                            <span className="tracking-[3px] text-[10px] lg:text-[18px]">
                              HOME
                            </span>
                            {/* <span>
                              <Icon icon="ant-design:down-outlined" />
                            </span> */}
                          </div>
                        </button>
                        {/* <div class="absolute z-10 hidden bg-[#1f1d1d] rounded-[10px] w-[260px] group-hover:block">
                          <div class="px-4 pt-3 pb-4 shadow-lg">
                            <div class="grid grid-cols-1 gap-4 md:grid-cols-1">
                              <NavLink to="/tournaments">
                                <p>Tournaments</p>
                              </NavLink>
                              <NavLink to="/seasons">
                                <p>Season Pass</p>
                              </NavLink>
                              <NavLink to="/summon">
                                <p>Summon</p>
                              </NavLink>
                              <NavLink to="/blood-queen-sacrifice">
                                <p>Blood Queen's Sacrifice (Burn)</p>
                              </NavLink>
                              <NavLink to="/blood-queen-gift">
                                <p>Blood Queen's Gift</p>
                              </NavLink>
                              <NavLink to="/leaderboards">
                                <p>Leaderboard (Season)</p>
                              </NavLink>
                            </div>
                          </div>
                        </div> */}
                      </div>

                      <div class="relative group">
                        <button class="flex flex-row items-center w-full lg:px-4 py-4 mt-2 text-base font-semibold text-left uppercase bg-transparent rounded-lg md:w-auto md:inline md:mt-0 md:ml-4 focus:outline-none font-montserrat">
                          <div class="flex items-center gap-2">
                            <span className="tracking-[3px] text-[10px] lg:text-[18px]">
                              WHITE PAPER
                            </span>
                            {/* <span>
                              <Icon icon="ant-design:down-outlined" />
                            </span> */}
                          </div>
                        </button>
                        {/* <div class="absolute z-10 hidden bg-[#1f1d1d] rounded-[10px] w-[210px] group-hover:block">
                          <div class="px-4 pt-3 pb-4 shadow-lg">
                            <div class="grid grid-cols-1 gap-4 md:grid-cols-1">
                              <NavLink to="/death">
                                <p>To The Death</p>
                              </NavLink>
                              <p>Rental</p>
                              <NavLink to="/leaderboard-classic">
                                <p>Leaderboards(classic)</p>
                              </NavLink>
                              <p>Darklands(coming soon)</p>
                            </div>
                          </div>
                        </div> */}
                      </div>
                      <div class="relative group">
                        <button class="flex flex-row items-center w-full lg:px-4 py-4 mt-2 text-base font-semibold text-left uppercase bg-transparent rounded-lg md:w-auto md:inline md:mt-0 md:ml-4 focus:outline-none font-montserrat">
                          <div class="flex items-center gap-2">
                            <span className="tracking-[3px] text-[10px] lg:text-[18px]">
                              PARTNERS
                            </span>

                            {/* <span>
                              <Icon icon="ant-design:down-outlined" />
                            </span> */}
                          </div>
                        </button>
                        {/* <div class="absolute z-10 hidden bg-[#1f1d1d] rounded-[10px] w-[180px] group-hover:block">
                          <div class="px-4 pt-3 pb-4 shadow-lg">
                            <div class="grid grid-cols-1 gap-4 md:grid-cols-1">
                              <NavLink to="/introduction">
                                <p>Introduction</p>
                              </NavLink>
                              <NavLink to="/champions">
                                <p>Search Champions</p>
                              </NavLink>
                              <NavLink to="/barracks">
                                <p>Search Barracks</p>
                              </NavLink>
                            </div>
                          </div>
                        </div> */}
                      </div>
                      <div class="relative group">
                        <button class="flex flex-row items-center w-full lg:px-4 py-4 mt-2 text-base font-semibold text-left uppercase bg-transparent rounded-lg md:w-auto md:inline md:mt-0 md:ml-4 focus:outline-none font-montserrat">
                          <div class="flex items-center gap-2">
                            <span className="tracking-[3px] text-[10px] lg:text-[18px]">
                              THE GAME
                            </span>

                            {/* <span>
                              <Icon icon="ant-design:down-outlined" />
                            </span> */}
                          </div>
                        </button>
                        {/* <div class="absolute z-10 hidden bg-[#1f1d1d] rounded-[10px] w-[180px] group-hover:block">
                          <div class="px-4 pt-3 pb-4 shadow-lg">
                            <div class="grid grid-cols-1 gap-4 md:grid-cols-1">
                              <NavLink to="/roadmap">
                                <p>Developemnet</p>
                              </NavLink>
                              <p>Game Guide</p>
                            </div>
                          </div>
                        </div> */}
                      </div>

                      <div class="relative group">
                        <a
                          href="https://www.pinksale.finance/launchpad/0x892C7A01a850aC61dAaEB2B650f9B3D0f2519996?chain=BSC"
                          target="_"
                        >
                          <button class="flex flex-row items-center w-full lg:px-4 py-4 mt-2 text-base font-semibold text-left uppercase bg-transparent rounded-lg md:w-auto md:inline md:mt-0 md:ml-4 focus:outline-none font-montserrat">
                            <div class="flex items-center gap-2">
                              <span className="tracking-[3px] text-[10px] lg:text-[18px]">
                                PinkSale
                              </span>
                            </div>
                          </button>
                        </a>
                      </div>
                    </nav>
                  </div>
                </div>
                {/* <div className="absolute z-[99] inset-y-0 right-0 flex gap-4 items-center pr-2   sm:ml-6 sm:pr-0">
                  <button
                    type="button"
                    className="rounded-full hidden sm:block px-5 w-[120px] py-2.5 text-sm font-bold text-white bg-[#7C0B0B] shadow-sm ring-1 ring-inset ring-[#7C0B0B] tracking-[2px] hover:bg-black hover:ring-[black]"
                  >
                    LOG IN
                  </button>
                  <button
                    type="button"
                    className="relative rounded-full p-1 text-white hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800"
                  >
                    <span className="absolute -inset-1.5" />
                    <span className="sr-only">View notifications</span>
                    <BellIcon className="h-6 w-6" aria-hidden="true" />
                  </button>
                </div> */}
              </div>
            </div>

            <Disclosure.Panel className="md:hidden">
              <div className="space-y-1 px-2 pb-3 pt-4 absolute top-[0] w-[100%] h-[100vh] justify-center text-center bg-[#1F1F1F] z-[999]">
                <div className="absolute z-[999]  top-[15px] right-[5px] flex items-center">
                  {/* Mobile menu button */}
                  <Disclosure.Button className="relative inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                    <span className="absolute -inset-0.5" />
                    <span className="sr-only">Open main menu</span>
                    {open ? (
                      <XMarkIcon className="block h-6 w-6" aria-hidden="true" />
                    ) : (
                      <Bars3Icon className="block h-6 w-6" aria-hidden="true" />
                    )}
                  </Disclosure.Button>
                </div>
                {/* <button
                  type="button"
                  className="rounded-full px-5 w-[120px] py-2.5 text-sm font-bold text-white  shadow-sm ring-1 ring-inset ring-[none] tracking-[2px] hover:bg-black hover:ring-[black]"
                >
                  LOG IN
                </button> */}
                {navigation.map((item) => (
                  <Disclosure.Button
                    key={item.name}
                    as="a"
                    href={item.href}
                    target="_"
                    className={classNames(
                      item.current
                        ? " text-white"
                        : "text-gray-300 hover:bg-gray-700 hover:text-white",
                      "block rounded-md px-3 py-2 text-base font-medium"
                    )}
                    aria-current={item.current ? "page" : undefined}
                  >
                    {item.name}
                  </Disclosure.Button>
                ))}
              </div>
            </Disclosure.Panel>
          </>
        )}
      </Disclosure>
    </>
  );
}
